<template>
  <div class="anonymous-wraps">
    <!-- <v-row no-gutters id="sortOption">
      <v-col cols="5">
        <v-row dense>
          <v-col
            v-for="(v, k) in filters.default"
            :key="k"
            v-if="v.length > 0"
            cols="4"
          >
            <div>
              <v-menu offset-y :close-on-content-click="false" v-model="config.panel[k]" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn slot="activator" class="box-container" v-bind="attrs" v-on="on" color="white" style="width: 100%">
                    <div class="d-flex justify-space-between w-100">
                      <div style="width: 75%;align-self:center"> {{k === 'assignedTo__email' ? 'Assigned To' : k}} </div>
                      <div>
                        <v-chip color="primary" class="white--text text-center" small style="max-width:40px"
                          v-if="filters.selected[k] && filters.selected[k].length"
                        >
                          {{ filters.selected[k].length }}
                        </v-chip>
                        <v-icon style="margin-top:5px;" v-if="config.panel[k]">fas fa-sort-up</v-icon>
                        <v-icon style="margin-bottom:5px;" v-else>fas fa-sort-down</v-icon>
                      </div>
                    </div>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-show="v.length > 0" v-for="chk in v" :key="chk[k]">
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-checkbox
                          color="primary"
                          hide-details
                          :ripple="false"
                          @change="triggerUpdate()"
                          :value="chk[k]"
                          v-model="filters.selected[k]"
                          class="ma-0 pa-0"
                        >
                          <div class="" slot="label">
                            <span v-if="k === 'mood'">
                              <img
                                v-if="chk[k] > 0"
                                height="30"
                                :src="getImgUrl(chk[k])"
                              >
                              <span v-if="chk[k] === 0">Not answered</span>
                            </span>
                            <span v-if="k !== 'mood' && k !== 'assignedTo__email' && chk[k] !== 'inProgress'">
                              {{chk[k]}}
                            </span>
                            <span v-if="k !== 'mood' && k !== 'assignedTo__email' && chk[k] === 'inProgress'">
                              In Progress
                            </span>
                            <span v-if="k === 'assignedTo__email'">
                              {{chk['assignedTo__display_name']}}
                            </span>
                          </div>
                        </v-checkbox>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-show="v.length === 0">
                    <v-list-item-content>
                      No filters available
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </v-col>
          <v-col class="d-flex align-center">
            <v-btn style="z-index: 100 !important;" color="primary"
              text
              icon
              v-show="checkForFilters"
              @click="resetDashboard"
            >
              <i class="las la-sync-alt"></i>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="3"></v-col>
      <v-col cols="4" class="d-flex justify-end pr-3">
        <div class="right d-flex align-center" v-if="totalAnonymousUsers && totalAnonymousUsers > 0">
          <div class="pre-icon cursor-pointer mr-3 pt-1" @click="displayPre()">
            <i class="las la-chevron-circle-left"></i>
          </div>
          <div>{{getPreNumber}} - {{getNextNumber}} of {{totalAnonymousUsers}}</div>
          <div class="next-icon cursor-pointer ml-3 pt-1" @click="displayNext()">
            <i class="las la-chevron-circle-right"></i>
          </div>
        </div>
      </v-col>
    </v-row> -->
    <div class="anonymous-msg-wrap">
      <v-row>
        <v-col cols="4" class="pr-0 py-0 px-0">
          <div class="left-side infinite-wrapper" style=" overflow-y:auto; overflow-x:hidden; border-right: 2px solid rgba(0,0,0,0.1);">
            <div class="users-list-wrap userSearchWithoutBorder">
              <v-row class="px-0 py-0 mx-0 my-0" style="    border-bottom: 1px solid rgba(0, 0, 0, 0.1);">
                <v-col cols="7" class="pr-0 py-0 px-0">
                  <v-text-field
                    placeholder="Search..."
                    v-model="queries"
                    @input="triggerUpdate()"
                  ></v-text-field>
                </v-col>
                <v-col
                  v-for="(v, k) in filters.default"
                  :key="k"
                  v-if="v.length > 0"
                  cols="2"  class="pr-0 py-0 px-0"
                >
                  <div class="">
                    <v-menu offset-y :close-on-content-click="false" v-model="config.panel[k]" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn slot="activator" class="box-container" v-bind="attrs" v-on="on" color="white" style="width: 100%; box-shadow:none !important;;">
                          <div class="d-flex justify-space-between w-100">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <p class="mb-0 pt-1" v-if="k !== 'assignedTo__email'">{{k}}</p>
                                <v-icon v-bind="attrs"
                                  v-on="on" v-if="k === 'assignedTo__email'">las la-user</v-icon>
                              </template>
                              <span v-if="k !== 'assignedTo__email'">Status</span>
                              <span v-if="k === 'assignedTo__email'">Assign to</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <div class="pt-1" v-bind="attrs"
                                  v-on="on" >
                                  <v-chip color="primary" class="white--text text-center" x-small style="max-width:40px; padding:0 5px;"
                                    v-if="filters.selected[k] && filters.selected[k].length"
                                  >
                                    {{ filters.selected[k].length }}
                                  </v-chip>
                                  <v-icon style="margin-top:5px;    font-size: 12px !important;" v-if="config.panel[k]">las la-angle-up</v-icon>
                                  <v-icon style="margin-bottom:5px;    font-size: 12px !important;;" v-else>las la-angle-down</v-icon>
                                </div>
                                </template>
                              <span v-if="k !== 'assignedTo__email'">Status</span>
                              <span v-if="k === 'assignedTo__email'">Assign to</span>
                            </v-tooltip>
                          </div>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item v-show="v.length > 0" v-for="chk in v" :key="chk[k]">
                          <v-list-item-content>
                            <v-list-item-title>
                              <v-checkbox
                                color="primary"
                                hide-details
                                :ripple="false"
                                @change="triggerUpdate()"
                                :value="chk[k]"
                                v-model="filters.selected[k]"
                                class="ma-0 pa-0"
                              >
                                <div class="" slot="label">
                                  <span v-if="k === 'mood'">
                                    <img
                                      v-if="chk[k] > 0"
                                      height="30"
                                      :src="getImgUrl(chk[k])"
                                    >
                                    <span v-if="chk[k] === 0">Not answered</span>
                                  </span>
                                  <span v-if="k !== 'mood' && k !== 'assignedTo__email' && chk[k] !== 'inProgress'">
                                    {{chk[k]}}
                                  </span>
                                  <span v-if="k !== 'mood' && k !== 'assignedTo__email' && chk[k] === 'inProgress'">
                                    In Progress
                                  </span>
                                  <span v-if="k === 'assignedTo__email'">
                                    {{chk['assignedTo__display_name']}}
                                  </span>
                                </div>
                              </v-checkbox>
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-show="v.length === 0">
                          <v-list-item-content>
                            No filters available
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </v-col>
                <v-col cols="1"  class="pr-0 py-0 px-0">
                  <v-btn style="z-index: 100 !important;" color="primary"
                    text
                    icon
                    v-show="checkForFilters"
                    @click="resetDashboard"
                  >
                    <i class="las la-sync-alt"></i>
                  </v-btn>
                </v-col>
              </v-row>
              <v-col v-if="anonymousUsersList.length === 0">
      <div class="no-sort-data text-center" style="margin:29vh 0;">
        No user found.
      </div>
    </v-col>
              <div
                class="user-card cursor-pointer hover-link"
                fluid
                v-for="(user,index) in anonymousUsersList"
                :key="index"
                :class="user.id === activeUser ? 'active': ''"
                @click="getDetails(user)"
              >
                <div class="card-top"  v-if="anonymousUsersList && anonymousUsersList.length > 0">
                  <div class="icon">
                    <v-avatar size="50" class="profile-avatar">
                      <img :src="getImgUrl('anonymous-user')" :alt="user.anonymous_name">
                    </v-avatar>
                  </div>
                  <div class="user-details w-100" >
                    <v-row style="margin-top:-8px;">
                      <v-col  class="pb-0" cols="8">
                        <div class="user-title">{{user.anonymous_name}}</div>
                      </v-col>
                      <v-col class="pb-0 pl-0" cols="4">
                        <v-chip
                          :class="{
                            'primary primary-bg-light primary--text' : user.status === 'open',
                            'orange orange-bg-light orange--text' : user.status === 'inProgress',
                            'success success-bg-light success--text' : user.status === 'resolved',
                          }"
                          style="text-transform:uppercase; font-weight:bold;"
                          outlined
                          small
                        >
                          {{user.status}}
                        </v-chip>
                      </v-col>
                      <div style="font-size:80%; padding-left:12px;">
                        <span class="font-weight-medium">Assigned to:</span>
                        <span v-if="!user.assignedTo_email">&nbsp;Not assigned</span>
                        <span style="overflow-wrap: break-word;" v-else>&nbsp;{{user.assignedTo_email}}</span>
                      </div>
                    </v-row>
                    <div class="user-status">
                      <!-- <div
                        class="ml-3 d-flex"
                        v-if="user.status === 'resolved' && user.dateResolved !== 'None'"
                      >
                        <v-tooltip bottom color="primary">
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on">
                              far fa-clock
                            </v-icon>
                            &nbsp;{{dayjs(user.dateResolved).from()}}
                          </template>
                          <span>
                            &nbsp;{{dayjs(user.dateResolved).format('DD MMM YYYY, HH:mm')}}&nbsp;
                          </span>
                        </v-tooltip>
                      </div> -->
                    </div>
                  </div>
                </div>
                <!-- <div class="card-bottom">
                </div> -->
              </div>
            </div>
            <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler" spinner="waveDots" force-use-infinite-wrapper=".infinite-wrapper">
            <span slot='no-more'>{{' '}}</span>
            <span slot='no-results'>{{' '}}</span>
          </infinite-loading>
          </div>
        </v-col>
        <v-col cols="8" class="px-0 py-0">
          <div class="right-side" style="">
            <v-container
              fluid
              class="pa-0"
            >
              <anonymous-ChatWindow ref="AnonymousChatWindow"
                @updateUserList="updateUserList"
              ></anonymous-ChatWindow>
            </v-container>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
// import { VPagination, VAvatar, VTooltip } from 'vuetify';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import InfiniteLoading from 'vue-infinite-loading';
import AnonymousChatWindow from './anonymous-chatWindow';

dayjs.extend(relativeTime);

export default {
  name: 'anonymousMessages',

  components: {
    // VPagination,
    // VAvatar,
    // VTooltip,
    InfiniteLoading,
    AnonymousChatWindow
  },

  data () {
    return {
      activeAnonymousView: 'snapshot',
      anonymousUsersList: [],
      infiniteId: new Date(),
      totalAnonymousUsers: 0,
      activeUser: '',
      queries: '',
      filters: {
        default: {},
        selected: {},
        main: {}
      },
      config: {
        panel: {}
      },
      pagination: {
        rowsPerPage: 10,
        page: 1,
        length: 1
      }
    };
  },

  beforeMount () {
    this.getAnonymousAnalysis();
    this.getFilters();
  },

  computed: {
    ...mapState({
      user: state => state.user,
      dashboardFilters: state => state.dashboardFilters,
      updateDashboardFilters: state => state.updateDashboardFilters
    }),
    getPreNumber () {
      const num = (this.pagination - 1) * 10 + 1;
      if (num > this.totalAnonymousUsers) {
        return this.totalAnonymousUsers;
      }
      return num;
    },
    getNextNumber () {
      const num = (this.pagination - 1) * 10 + 10;
      if (num > this.totalAnonymousUsers) {
        return this.totalAnonymousUsers;
      }
      return num;
    },
    checkForFilters () {
      let applied = false;
      this.$lodash.each(this.filters.selected, (v) => {
        if (v.length > 0) {
          applied = true;
        }
      });
      return applied;
    }
  },

  watch: {
    anonymousUsersList: {
      deep: true,
      handler () {
        this.getDetails(this.anonymousUsersList[0]);
      }
    },
    $route: {
      deep: true,
      immediate: true,
      handler () {
        if (this.$route.query && this.$route.query.assignedTo) {
          this.filters.selected = { assignedTo__email: this.$route.query.assignedTo };
        }
      }
    }
  },

  methods: {
    infiniteHandler ($state) {
      console.log($state, 'abcstate');
      this.getAnonymousAnalysis($state);
    },
    getFilters () {
      axios.get(`${process.env.VUE_APP_BASE_API_URL}anonymous_bot/message/filters`).then((response) => {
        if (response && response.data && response.data) {
          // this.config.initialLoadingFilters = false;
          this.filters.default = response.data;

          const defaultFilters = {};
          this.$lodash.each(this.filters.default, (v, k) => {
            defaultFilters[k] = [];
          });
          if (Object.keys(this.filters.selected).length === 0) {
            this.filters.selected = defaultFilters;
            this.filters.main = JSON.parse(JSON.stringify(defaultFilters));
          }
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to get filter, Please try again later!'
          });
        }
      });
    },
    resetDashboard () {
      this.filterApplied = false;
      const temp = {
        ...this.updateDashboardFilters
      };
      this.$router.push({
        path: '/',
        query: {
          tab: 'anonymous-message',
          filters: JSON.stringify(temp)
        }
      }).catch(() => {});
      this.filters.selected = JSON.parse(JSON.stringify(this.filters.main));
      this.triggerUpdate();
    },
    triggerUpdate () {
      this.showFilter = false;
      this.config.panel = {};
      this.pagination.page = 1;
      this.infiniteId += 1;
      this.anonymousUsersList = [];
      this.getAnonymousAnalysis();
    },
    updateUserList () {
      this.getAnonymousAnalysis();
    },
    displayPre () {
      if (this.pagination > 1) {
        this.pagination = this.pagination - 1;
        // this.$emit('getEmployees', this.pagination);
        this.getAnonymousAnalysis();
      }
    },
    displayNext () {
      if (this.pagination < (this.totalAnonymousUsers / 10)) {
        this.pagination = this.pagination + 1;
        // this.$emit('getEmployees', this.pagination);
        this.getAnonymousAnalysis();
      }
    },
    togglePagination () {
      this.getAnonymousAnalysis();
    },
    getAnonymousAnalysis ($state) {
      const queryParams = {
        count: 'true',
        page_limit: this.pagination.rowsPerPage,
        page_offset: this.pagination.page || 1,
        fields: 'message,status,createdAt,anonymous_name,has_shared_identity,assignedTo,assignedTo_name,assignedTo_email,dateResolved',
        message__icontains: this.queries ? this.queries : null
      };
      // TODO :: apply filters

      this.$lodash.each(this.filters.selected, (v, k) => {
        if (typeof v === 'string') {
          v = v.split(',');
        }
        if (v.length > 0) {
          queryParams[`${k}__in`] = v.join();
        }
      });
      axios.get(`${process.env.VUE_APP_BASE_API_URL}anonymous_bot/message/list`, {
        params: queryParams
      }).then((response) => {
        if (response && response.data) {
          // this.anonymousUsersList = response.data.data;
          // this.totalAnonymousUsers = response.data.total_count;

          if (this.pagination.page === 1 || queryParams.page_offset === 1) {
            this.anonymousUsersList = [];
            // this.$emit('allComment', this.comments);
          }
          if (response.data.total_count > this.anonymousUsersList.length) {
            if ($state) {
              this.pagination.page += 1;
            }
            // console.log('this.comments = [];', this.comments);
            const temp = [];
            if (this.anonymousUsersList.length > 0) {
              this.$lodash.each(this.anonymousUsersList, (val) => {
                temp.push(val);
              });
            }
            this.$lodash.each(response.data.data, (val) => {
              temp.push(val);
            });
            // this.comments = [];
            // this.$emit('allComment', this.comments);
            this.anonymousUsersList = temp;
            // this.$emit('allComment', this.comments);
            if ($state) {
              $state.loaded();
            }
          } else {
            $state.complete();
          }
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to fetch details, Please try again later!'
          });
        }
      });
    },
    getDetails (user) {
      if (!user) {
        this.$refs.AnonymousChatWindow.activeAnonymousUser = null;
      }
      this.activeUser = user.id;
      this.$refs.AnonymousChatWindow.getAdditionalDetails(user);
      const elmnt = document.getElementById('sortOption');
      if (elmnt) {
        elmnt.scrollIntoView();
      }
    },
    getImgUrl (pet) {
      const images = require.context('@/assets/', false, /\.png$/);
      return images(`./${pet}.png`);
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  text-align: center;
  padding: 10px 0;
  .anonymous-pagination {
    list-style: none;
    display: flex;
    li {
      padding: 0 5px;
    }
    .pagination-btn {
      background: #fff;
      max-height: 26px;
      min-width: 26px;
      min-height: 26px;
      border-radius: 4px;
      padding: 2px 10px;
      cursor: pointer;
      &.active {
        background: #050550;
        color: #ffffff;
      }
    }
    .pagination-dots {
      font-size: 20px;
      padding: 0 10px;
      color: #050550;
    }
    .pagination-nav-left {
      i {
        font-size: 20px;
        padding-right: 12px;
        color: #050550;
        padding-top: 2px;
        cursor: pointer;
      }
      &.disabled {
        opacity: .6;
        pointer-events: none;
      }
    }
    .pagination-nav-right {
      &.disabled {
        opacity: .6;
        pointer-events: none;
      }
      i {
        cursor: pointer;
        font-size: 20px;
        padding-left: 12px;
        color: #050550;
        padding-top: 2px;
      }
    }
  }
}
.anonymous-msg-wrap {
  // display: flex;
  // width: 100%;
  // display: grid;
  // grid-template-columns: 3fr 8fr;
  grid-gap: 0px;
  margin: 0 12px;
  // height: 75vh;
  // overflow: hidden;
  // min-height: 75vh;
  // max-height: 75vh;
  .v-btn:not(.v-btn--text):not(.v-btn--outlined):hover:before {
    opacity: 0 !important;
  }
  .left-side {
    position: relative;
    max-height: calc(100vh - 160px);
    // width: 30%;
    // margin: 0 0 0 20px;
    // overflow-y: hidden;
    .users-list-wrap {
      // min-height: calc(82vh - 100px);
      // max-height: calc(82vh - 100px);
      // height: calc(82vh - 100px);
      // overflow-y: auto;
      .user-card {
        padding: 8px 16px;
        padding-right: 10px;
        background-color: var(--bg);
        border-radius: 0px !important;
        // box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
        // box-shadow: 0px 3px 20px #0000000b;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        .card-top {
          display: flex;
          padding: 0px 0px 0 0px;
          .user-details {
            padding-left: 20px;
            .user-title {
              font-size: var(--content-size);
              font-weight: 500;
            }
            .user-status {
              display: flex;
            }
          }
          .icon {
            img {
              // border: 2px solid #898989;
            }
          }
        }
        .card-bottom {
          padding: 0px 0px;
        }
        &:hover {
          // background: #edebf5;
          // background: var(--bg-panel);
        }
        &.active {
          background-color: #e6e6e67d;
          margin-right: 0;
        }
      }
    }
  }
  .right-side {
    // height: 65rem;
    // background-image: url('../../../assets/chat-bg.jpg');
    // background-image: url('../../../assets/background.jpg');
    // background-size: cover;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
}
</style>
<style lang="scss">
.userSearchWithoutBorder {
  .v-text-field > .v-input__control > .v-input__slot:before, .v-text-field > .v-input__control > .v-input__slot:after {
    display: none !important;
  }
  .v-input__slot {
    padding: 0 20px;
  }
  .v-text-field__details {
    display: none;
  }
  .v-text-field {
    padding: 0 !important;
    margin: 5px 0 0 0 !important;
  }
  .v-chip__content {
    font-weight: bold !important;
  }
  .primary-bg-light {
    border: none !important;
    padding: 0 !important;
    .v-chip__content {
      padding: 0 10px !important;
      background-color: #dcdcf1 !important;
    }
  }
  .orange-bg-light {
    border: none !important;
    padding: 0 !important;
    .v-chip__content {
      padding: 0 10px !important;
      background-color: #fff4e5 !important;
    }
  }
  .success-bg-light {
    border: none !important;
    padding: 0 !important;
    .v-chip__content {
      padding: 0 10px !important;
      background-color: #e5ffe6 !important;
    }
  }
}
</style>
